import React, { useEffect } from 'react'
import { Helmet } from '../../common/Helmet';
import { Outlet } from 'react-router-dom'
import CardLayout from '../../common/cardLayout/CardLayout'
import YouthLogoDark from "../../../assets/images/youth_logo_dark.png";
import HeaderImage from "../../../assets/images/header_home-large.jpg";
import AppStoreBadge from "../../../assets/images/badge_appstore.png";
import PlayStoreBadge from "../../../assets/images/badge_playstore.png";
import "./Applink.css";

const Applink = ()=> {
useEffect(()=>{
    const userAgent = window.navigator.userAgent.toLowerCase();
    //  const userAgent = "iphone"
    console.log("userAgent: " , userAgent)
      if (userAgent.includes("android")) {
        window.location.href = "https://play.google.com/store/apps/details?id=com.adolrose";
      } else if (userAgent.includes("iphone") || userAgent.includes("ipad")) {
        window.location.href = "https://apps.apple.com/us/app/rose-youth/id1596079012";
      } else {
        // Handle other platforms or fallback behavior
      }
},[])
  return (
    <section className="container-fluid loginBG">
      <Helmet>
        <meta charSet="utf-8" />
        <title>App Links</title>
        <link rel="canonical" href={window.location.origin} />
      </Helmet>
      <div
        className="col-sm-12 col-lg-10 col-md-10"
        style={{ margin: "0 auto" }}
      >
        <div className="row p-5">
          <div className="col-sm-12 col-lg-6 col-md-6">
            <CardLayout
              className="container col-sm-12 col-md-8 col-lg-8"
              style={{ marginTop: "5%" }}
            >
              <div className=" container-fluid py-3">
                <img
                  src={
                    YouthLogoDark
                  }
                  height="30%"
                  width="30%"
                  alt="Rose Health"
                />
                <div className="container pt-5">
                  <h1 className="primary-text" style={{textAlign: 'left'}}>OOPS!</h1>
                  <span className="secondary-text" style={{textAlign: 'left'}}>What you're trying to find is best experienced through the ROSE Youth app. Please open your app or download from the stores linked below.</span>
                </div>
                <div className="container pt-5">
                <a href="https://apps.apple.com/us/app/rose-youth/id1596079012" target="_blank">
                    <img
                      src={AppStoreBadge}
                      height="40%"
                      width="40%"
                      alt="Rose Health"
                      style={{ marginRight: '10px' }}
                    /></a>
                    <a href="https://play.google.com/store/apps/details?id=com.adolrose" target="_blank">
                    <img
                      src={PlayStoreBadge}
                      height="40%"
                      width="40%"
                      alt="Rose Health"
                      /></a>
                </div>
              </div>
            </CardLayout>
          </div>
          <div className="col-sm-12 col-lg-6 col-md-6">
            <div className="container text-center"  style={{ marginTop: "5%" }}>
            <img
                src={HeaderImage}
                alt="Welcome to Rose Health"
                className="img-fluid responsive-img"
                style={{ height: "70vh" }}
              />
            </div>
          </div>
        </div>
      </div>
      <Outlet />
    </section>
  )
}

export default Applink